import { createContext } from "react";

export const CatalogoContext = createContext();
